export class WebhookV1ProtobufDuration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "seconds",
            "baseName": "seconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nanos",
            "baseName": "nanos",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1ProtobufDuration.attributeTypeMap;
    }
    constructor() {
    }
}
